@use "../../styles/breakpoint.module.scss" as *;

.root {
    display: grid;
    grid-template-columns: 1fr min-content 1fr;
    grid-column: content;
    column-gap: var(--spacer-32);
    align-items: stretch;

    @media ($below-mobile) {
        grid-template-columns: 1fr;
        row-gap: var(--spacer-40);
    }
}

.divider {
    height: auto;

    --color: var(--red);

    @media ($below-mobile) {
        display: none;
    }
}

.left {
    display: flex;
    flex-direction: column;
    position: sticky;
    align-self: start;
    top: var(--spacer-gutter);
    margin-right: var(--extra-center-padding);

    @media ($below-mobile) {
        position: static;
    }
}

.rightContainer {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-auto-rows: min-content;
    column-gap: inherit;
    row-gap: var(--spacer-32);

    :where(& > *) {
        grid-column: 1 / -1;
        justify-self: start;
    }
}

.eyebrow {
    composes: fontB20 from "../../styles/typography.module.scss";
    font-weight: 800;
}

.heading {
    composes: fontHB80 from "../../styles/typography.module.scss";
    text-wrap: balance;
}

.subhead {
    composes: fontSH40 from "../../styles/typography.module.scss";
}

.body {
    composes: fontP20 from "../../styles/typography.module.scss";
}

.cta {
    composes: base from "../Clickables/index.module.scss";
    composes: fontHB32 from "../../styles/typography.module.scss";
    display: inline-flex;
    justify-content: space-between;
}

.leftColoredPromo {
    composes: left;
    padding: var(--spacer-32);
    gap: var(--spacer-16);

    .heading {
        flex-grow: 1;
    }

    .body {
        margin-block: var(--spacer-40);
    }

    @media ($above-mobile) {
        min-height: 640px;
    }
}

.leftImagePromo {
    composes: left;

    figure {
        margin-block: var(--spacer-56);
        align-self: center;
        max-width: 70%;
    }

    picture {
        aspect-ratio: 3 / 4;
    }

    .separator {
        --color: var(--black);

        margin-bottom: var(--spacer-24);
    }

    background: var(--neutral);
    padding: var(--spacer-32);
    padding-top: 0;
}

.leftRichtextShowcase {
    composes: left;
    row-gap: var(--spacer-24);

    .eyebrow {
        margin-bottom: var(--spacer-16);
    }

    .heading,
    .subhead,
    .body {
        margin-bottom: var(--spacer-24);
    }

    & > * {
        align-self: start;
    }
}

.articleCategory {
    composes: fontST16 from "../../styles/typography.module.scss";
    font-weight: 800;
    margin-bottom: var(--spacer-12);
}

.articleTitle {
    composes: base from "../Clickables/index.module.scss";
    composes: fontSH24 from "../../styles/typography.module.scss";
    text-wrap: pretty;
}

.rightArticleGrid {
    display: flex;
    grid-column: span 1;
    flex-direction: column;
    gap: var(--spacer-56);

    img {
        aspect-ratio: var(--image-ar);
        margin-bottom: var(--spacer-16);
        object-fit: cover;
    }

    article {
        cursor: pointer;

        &:hover,
        &:focus-within {
            & img {
                box-shadow: var(--box-shadow-2);
            }
        }
    }
}

.cardList {
    display: grid;
    grid-template-columns: subgrid;
    align-items: center;
    gap: var(--spacer-12) var(--spacer-gutter);

    > * {
        @media ($below-tablet) {
            grid-column: span 2;
        }

        @media ($below-mobile) {
            grid-column: span 1;
        }
    }

    > :last-child {
        @media ($below-tablet) {
            max-width: 200px;
        }

        @media ($below-mobile) {
            max-width: 100%;
        }
    }

    img {
        aspect-ratio: 3 / 2;
        object-fit: cover;
    }
}

.olHeading {
    composes: fontHB48 from "../../styles/typography.module.scss";
    margin-bottom: var(--spacer-24);
}

.rightOrderedList {
    composes: listReset from "../../styles/utils.module.scss";
    display: flex;
    flex-direction: column;
    row-gap: calc(2 * var(--spacer-40) + 1px);

    & > li {
        position: relative;

        &:not(:last-child)::after {
            content: "";
            background: var(--mid-gray);
            position: absolute;
            bottom: calc(-1 * var(--spacer-40));
            inset-inline: 0;
            height: 1px;
        }
    }
}

.rightOrderedListWithNumbers {
    composes: rightOrderedList;

    --margin: 48px;

    padding-left: var(--margin);

    & > li {
        counter-increment: level1;

        &::before {
            content: counter(level1) ". ";
            font: var(--font-hb-48);
            color: var(--red);
            position: absolute;
            left: calc(-1 * var(--margin));
            top: 0;
        }

        &:nth-of-type(-n + 9)::before {
            content: "0" counter(level1) ". ";
        }

        &:not(:last-child)::after {
            left: calc(-1 * var(--margin));
        }
    }
}
